import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { validateNumberAndLetterAndSpace } from '../../../util/CommonUtils';
import { getPropCodeType } from '../../../util/ContractAdminUtils';
import CommonDropdown from '../../common/CommonDropdown';
import { CancelButton, StyledButton } from '../styledComponents';

const PropCodeGenerate = ({
  IsClosePropCodePopup,
  propCodeTypes,
  generatePropCode,
  propCodeError,
}) => {
  const [propCodeDescription, setPropCodeDescription] = useState('');
  const [propCodeTypeDescription, setPropCodeTypeDescription] = useState(null);
  const [propCodeNote, setPropCodeNote] = useState('');
  const [tyeps, setTypes] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    setErrorMsg(propCodeError);
  }, [propCodeError]);

  useEffect(() => {
    setTypes(getPropCodeType(propCodeTypes));
  }, [propCodeTypes]);
  const generate = () => {
    setErrorMsg('');
    if (!propCodeDescription.trim() && !propCodeTypeDescription) {
      setErrorMsg('Prop Code Description & Type is Required');
    } else if (!propCodeDescription.trim()) {
      setErrorMsg('Prop Code Description is Required');
    } else if (!propCodeTypeDescription) {
      setErrorMsg('PropCode Type is Required');
    } else {
      generatePropCode({
        propCodeDescription,
        propCodeTypeDescription: propCodeTypeDescription.label,
        propCodeNote,
      });
    }
  };
  const setDesc = val => {
    setErrorMsg('');
    const value = validateNumberAndLetterAndSpace(val);
    if (val && !value) {
      setErrorMsg('Description Should allow Only Numbers and Letters');
    } else {
      setPropCodeDescription(val);
    }
  };
  const selectedType = val => {
    setErrorMsg('');
    setPropCodeTypeDescription(val);
  };
  const setNote = val => {
    setErrorMsg('');
    const value = validateNumberAndLetterAndSpace(val);
    if (val && !value) {
      setErrorMsg('Note Should allow Only Numbers and Letters');
    } else {
      setPropCodeNote(val);
    }
  };
  return (
    <div className="propcode">
      <div className="propcode-desc">
        <label>
          Prop Code Description <span className="required">*</span>
        </label>
        <input
          type="text"
          value={propCodeDescription}
          onChange={e => setDesc(e.target.value)}
          maxLength="60"
          required="required"
        />
      </div>
      <div className="propcode-type">
        <label>
          Prop Code Type <span className="required">*</span>
        </label>
        <CommonDropdown
          data-test="propcodeType"
          listData={tyeps}
          defaultSelected={propCodeTypeDescription}
          placeHolder="Select Prop Code Type"
          itemClickFn={e => selectedType(e)}
        />
      </div>
      <div className="propcode-note">
        <label htmlFor="propcode-note">Notepad</label>
        <span>
          Please include the study name and additional details for this request.
        </span>
        <textarea
          id="propcode-note"
          value={propCodeNote}
          maxLength="200"
          onChange={e => setNote(e.target.value)}
        />
      </div>
      {errorMsg && <div className="propcode-error"> {errorMsg}</div>}
      <div className="propcode-buttons">
        <CancelButton onClick={IsClosePropCodePopup}>Cancel</CancelButton>
        <StyledButton width="30%" onClick={() => generate()}>
          Generate
        </StyledButton>
      </div>
    </div>
  );
};

PropCodeGenerate.propTypes = {
  IsClosePropCodePopup: PropTypes.bool,
  propCodeTypes: PropTypes.shape([]),
  generatePropCode: PropTypes.func,
  propCodeError: PropTypes.string,
};
export default memo(PropCodeGenerate);
